import React from 'react';
import { useNavigate } from 'react-router-dom';

import {
  Container,
  UnpaidInvoicesContainer,
  UnpaidInvoicesIconContainer
} from './UnpaidInvoices.styled';
import UnpaidInvoicesIcon from 'assets/icons/unpaid-invoices.svg?react';
import { Button } from 'components/v2/Buttons/Button/Button';
import { Heading } from 'components/v2/Typography/Heading';
import { useUnpaidInvoicesCount } from 'screens/Invoices/hooks/useUnpaidInvoicesCount';
import { pageUrl } from 'utilities/pageUrl';

export const UnpaidInvoices = () => {
  const navigate = useNavigate();

  const { unpaidInvoicesCount: count } = useUnpaidInvoicesCount();
  if (count === 0) return null;

  return (
    <Container>
      <UnpaidInvoicesIconContainer>
        <UnpaidInvoicesIcon />
      </UnpaidInvoicesIconContainer>
      <UnpaidInvoicesContainer>
        <Heading tag="h2" noMargin>
          You have {count} unpaid invoice
          {count > 1 ? 's' : ''}!
        </Heading>
        <Button
          category="error"
          label={`View Invoice${count > 1 ? 's' : ''}`}
          onClick={() => navigate(pageUrl.invoices({ tabId: 'invoices' }))}
        />
      </UnpaidInvoicesContainer>
    </Container>
  );
};
